export default "__VITE_ASSET__9tK7$hjU__"